'use client';

import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { STATES_MAP } from '@repo/supergraph/marketplace/constants';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { getSafeRegionCodeFromClientCookies } from '../../utils/geo-data';

export function BankingReviewsEyebrow({
  stateForEyebrow,
}: {
  stateForEyebrow?: StateAbbreviation;
}) {
  const [updatedEyebrow, setUpdatedEyebrow] = useState('Editorial Review');

  useEffect(() => {
    const regionCode = getSafeRegionCodeFromClientCookies();
    const regionCodeToUse = regionCode ?? stateForEyebrow;
    if (regionCodeToUse) {
      setUpdatedEyebrow(`Editorial Review - ${STATES_MAP[regionCodeToUse]}`);
    }
  }, []);

  if (!stateForEyebrow) {
    return null;
  }

  return (
    <Typography variant="accentSmall" sx={{ marginBottom: 2 }}>
      {updatedEyebrow}
    </Typography>
  );
}
